import { Button, ActionButton } from '@cycle-app/ui';
import { body400, caption400 } from '@cycle-app/ui/theme/typo';
import styled from 'styled-components';

import DialogModal from 'src/components/DialogModal/DialogModal';

export const Container = styled.div`
  display: flex;
`;

export const SlotContainer = styled.div<{ $isSpaced?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${p => (p.$isSpaced ? 'space-between' : 'flex-start')};
  width: 100%;
`;

export const IconContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 0px 8px;
  color: ${p => p.theme.colors.text.disabled};

  svg {
    width: 12px;
    height: 12px;
  }
`;

export const RemoveModalStyled = styled(DialogModal)`
  width: 548px;
`;

export const StyledLineButton = styled(Button)`
  width: 100%;
`;

export const StyledActionButton = styled(ActionButton)`
  height: 24px;
`;

export const ActionsMenu = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 170px;
  max-width: 332px;
  border-radius: 8px;
  padding: 8px 0;
`;

export const ActionMenu = styled.div`
  width: 100%;
  background-color: ${p => p.theme.colors.selectItem.bg};
  color: ${p => p.theme.colors.selectItem.color};
  display: flex;
  gap: 12px;
  cursor: pointer;
  padding: 0 12px;
  &:hover {
    background-color: ${p => p.theme.colors.selectItem.bgHover};
  }
  > svg {
    margin: 9px 0;
    width: 14px;
    min-width: 14px;
    height: 14px;
  }
`;

export const ActionMenuContent = styled.div`
  padding: 4px 0;
  flex: 1;
  text-align: left;
`;

export const ActionMenuIcon = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  height: 100%;
  min-width: 16px;
  padding-top: 9px;
  color: ${p => p.theme.colors.text.primary};

  svg {
    min-width: 14px;
    min-height: 14px;
  }
`;

export const ActionMenuTextTitle = styled.h3`
  ${body400}
  color: ${p => p.theme.colors.text.primary};
`;

export const ActionMenuTextDescription = styled.p`
  ${caption400}
  color: ${p => p.theme.colors.text.secondary};
`;
